import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './SteamTestPage.scss';

class SteamTestPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'user-info',
      isLoading: false,
      testResults: {},
      appIdInput: '',
      steamIdInput: '',
      userDataLoaded: false
    };
  }

  componentDidMount() {
    // 确保获取最新的用户信息，包括Steam连接状态
    const { token } = this.props.auth;
    if (token) {
      // 先调用 getInitialInfo 确保用户数据是最新的
      this.props.getInitialInfo(token);
    }
    
    // 🔧 新增：检查URL参数，如果有callback_failed错误则自动诊断
    const urlParams = new URLSearchParams(window.location.search);
    const steamError = urlParams.get('error');
    if (steamError === 'callback_failed') {
      console.log('🚨 检测到Steam callback_failed错误，开始自动诊断...');
      this.handleDiagnoseSteamBindingFailure();
    }
    
    // 自动获取用户基本信息
    this.handleGetUserInfo();
    
    // 调试：输出用户Steam连接信息
    const { user } = this.props.auth;
    console.log('=== Steam连接状态调试 ===');
    console.log('完整用户信息:', user);
    console.log('connectedAccounts:', user?.connectedAccounts);
    console.log('Steam账户对象:', user?.connectedAccounts?.steam);
    console.log('Steam ID:', user?.connectedAccounts?.steam?.id);
    console.log('Steam username:', user?.connectedAccounts?.steam?.username);
    console.log('判断结果 - 是否已连接:', !!user?.connectedAccounts?.steam?.id);
    console.log('========================');
  }

  componentDidUpdate(prevProps) {
    // 当用户信息更新后，重新检查Steam连接状态
    const { user: prevUser } = prevProps.auth;
    const { user: currentUser } = this.props.auth;
    
    if (prevUser !== currentUser) {
      console.log('=== 用户信息已更新 ===');
      console.log('🔧 修复验证：检查Steam数据同步是否正常工作');
      
      // 详细的平台连接状态对比
      const prevConnectedAccounts = prevUser?.connectedAccounts || {};
      const currentConnectedAccounts = currentUser?.connectedAccounts || {};
      
      console.log('=== 平台连接状态对比 ===');
      console.log('Twitch - 之前:', prevConnectedAccounts.twitch?.id ? '已连接' : '未连接');
      console.log('Twitch - 现在:', currentConnectedAccounts.twitch?.id ? '已连接' : '未连接');
      console.log('Twitter - 之前:', prevConnectedAccounts.twitter?.id ? '已连接' : '未连接');
      console.log('Twitter - 现在:', currentConnectedAccounts.twitter?.id ? '已连接' : '未连接');
      console.log('YouTube - 之前:', prevConnectedAccounts.youtube?.id ? '已连接' : '未连接'); 
      console.log('YouTube - 现在:', currentConnectedAccounts.youtube?.id ? '已连接' : '未连接');
      console.log('Steam - 之前:', prevConnectedAccounts.steam?.id ? '已连接' : '未连接');
      console.log('Steam - 现在:', currentConnectedAccounts.steam?.id ? '已连接' : '未连接');
      
      // 🔧 新增：验证validateUserHandshake修复是否生效
      if (!prevConnectedAccounts.steam?.id && currentConnectedAccounts.steam?.id) {
        console.log('✅ 修复验证：Steam连接数据已成功同步！');
        console.log('🔑 validateUserHandshake修复生效，Steam数据正常加载');
      }
      
      // 检查是否只有Steam数据丢失
      const twitchLost = prevConnectedAccounts.twitch?.id && !currentConnectedAccounts.twitch?.id;
      const twitterLost = prevConnectedAccounts.twitter?.id && !currentConnectedAccounts.twitter?.id;
      const youtubeLost = prevConnectedAccounts.youtube?.id && !currentConnectedAccounts.youtube?.id;
      const steamLost = prevConnectedAccounts.steam?.id && !currentConnectedAccounts.steam?.id;
      
      if (steamLost && !twitchLost && !twitterLost && !youtubeLost) {
        console.log('🚨 警告：只有Steam连接数据丢失，其他平台数据完整！');
        console.log('❌ 修复可能未完全生效，需要进一步调试');
      }
      
      // 详细显示Steam数据变化
      if (currentConnectedAccounts.steam?.id) {
        console.log('Steam ID:', currentConnectedAccounts.steam.id);
        console.log('Steam Username:', currentConnectedAccounts.steam.username);
      } else {
        console.log('Steam连接数据不存在或为空');
        console.log('Steam对象详情:', currentConnectedAccounts.steam);
      }
      
      console.log('=========================');
      
      // 标记用户数据已加载
      if (!this.state.userDataLoaded && currentConnectedAccounts) {
        this.setState({ userDataLoaded: true });
      }
      
      // 强制更新组件显示
      this.forceUpdate();
    }
  }

  // 🔧 创建全面的用户数据诊断工具
  handleDiagnoseUserData = () => {
    const { user, token } = this.props.auth;
    
    console.group('🔍 === 完整用户数据诊断 ===');
    console.log('诊断时间:', new Date().toISOString());
    console.log('JWT Token 存在:', !!token);
    console.log('JWT Token 前缀:', token ? token.substring(0, 20) + '...' : 'null');
    
    console.group('👤 用户基本信息');
    console.log('用户对象存在:', !!user);
    console.log('用户ID:', user?.id);
    console.log('用户名:', user?.username);
    console.log('显示名:', user?.displayName);
    console.log('角色:', user?.role);
    console.log('验证握手值:', user?.validationHandshake);
    console.groupEnd();
    
    console.group('🔗 connectedAccounts 详细分析');
    const connectedAccounts = user?.connectedAccounts;
    console.log('connectedAccounts 对象存在:', !!connectedAccounts);
    console.log('connectedAccounts 类型:', typeof connectedAccounts);
    console.log('connectedAccounts 完整内容:', connectedAccounts);
    
    if (connectedAccounts) {
      console.group('📺 平台连接详情');
      
      // Twitch 分析
      console.group('Twitch');
      console.log('Twitch 对象:', connectedAccounts.twitch);
      console.log('Twitch ID:', connectedAccounts.twitch?.id);
      console.log('Twitch 用户名:', connectedAccounts.twitch?.username);
      console.log('Twitch 连接状态:', !!connectedAccounts.twitch?.id);
      console.groupEnd();
      
      // Twitter 分析
      console.group('Twitter');
      console.log('Twitter 对象:', connectedAccounts.twitter);
      console.log('Twitter ID:', connectedAccounts.twitter?.id);
      console.log('Twitter 用户名:', connectedAccounts.twitter?.username);
      console.log('Twitter 连接状态:', !!connectedAccounts.twitter?.id);
      console.groupEnd();
      
      // YouTube 分析
      console.group('YouTube');
      console.log('YouTube 对象:', connectedAccounts.youtube);
      console.log('YouTube ID:', connectedAccounts.youtube?.id);
      console.log('YouTube 频道名:', connectedAccounts.youtube?.channelTitle);
      console.log('YouTube 连接状态:', !!connectedAccounts.youtube?.id);
      console.groupEnd();
      
      // Steam 详细分析
      console.group('🎮 Steam 详细诊断');
      const steam = connectedAccounts.steam;
      console.log('Steam 对象存在:', !!steam);
      console.log('Steam 对象类型:', typeof steam);
      console.log('Steam 完整对象:', steam);
      
      if (steam) {
        console.log('Steam 属性检查:');
        console.log('  - id:', steam.id, '(类型:', typeof steam.id, ')');
        console.log('  - username:', steam.username);
        console.log('  - profileUrl:', steam.profileUrl);
        console.log('  - avatarUrl:', steam.avatarUrl);
        console.log('  - realName:', steam.realName);
        console.log('  - lastSyncAt:', steam.lastSyncAt);
        console.log('  - 所有属性:', Object.keys(steam));
        console.log('  - 连接判断:', !!steam.id);
      } else {
        console.log('❌ Steam 对象不存在或为 null/undefined');
        
        // 检查其他可能的 Steam 数据位置
        console.log('检查 user 对象其他位置的 Steam 数据:');
        console.log('user.steam:', user?.steam);
        console.log('user.steamId:', user?.steamId);
        console.log('user.steamAccount:', user?.steamAccount);
        
        // 检查对象的所有属性
        if (user) {
          console.log('用户对象所有属性:');
          Object.keys(user).forEach(key => {
            if (key.toLowerCase().includes('steam')) {
              console.log(`  ${key}:`, user[key]);
            }
          });
        }
      }
      console.groupEnd();
      
      console.groupEnd();
    }
    console.groupEnd();
    
    console.group('🌐 网络状态检查');
    console.log('在线状态:', navigator.onLine);
    console.log('URL 参数:', new URLSearchParams(window.location.search).toString());
    console.log('localStorage token:', localStorage.getItem('token') ? '存在' : '不存在');
    console.log('sessionStorage 数据:', Object.keys(sessionStorage).length, '项');
    console.groupEnd();
    
    console.groupEnd();
    
    // 如果Steam数据丢失，建议修复操作
    if (!user?.connectedAccounts?.steam?.id) {
      console.group('🔧 修复建议');
      console.log('检测到 Steam 数据丢失，建议执行以下操作:');
      console.log('1. 点击"验证握手值"按钮刷新用户数据');
      console.log('2. 检查后端 Steam 绑定记录');
      console.log('3. 重新执行 Steam 绑定流程');
      console.log('4. 检查数据库中的 connectedAccounts.steam 字段');
      console.groupEnd();
    }
  };

  // 验证握手值并强制刷新用户数据
  handleValidateHandshake = async () => {
    const { token, user } = this.props.auth;
    
    console.group('🔄 验证握手值操作');
    console.log('操作时间:', new Date().toISOString());
    console.log('当前握手值:', user?.validationHandshake);
    
    if (!token) {
      console.error('❌ JWT Token 不存在，无法验证握手值');
      console.groupEnd();
      return;
    }
    
    try {
      console.log('🚀 开始调用 validateUserHandshake...');
      
      // 使用空字符串作为握手值，强制后端返回最新数据
      this.props.validateUserHandshake(token, '');
      
      console.log('✅ validateUserHandshake 已调用，等待响应...');
      
      // 设置一个定时器来监控更新结果
      setTimeout(() => {
        console.log('⏰ 5秒后检查更新结果:');
        const updatedUser = this.props.auth.user;
        console.log('更新后的 Steam 连接状态:', !!updatedUser?.connectedAccounts?.steam?.id);
        if (updatedUser?.connectedAccounts?.steam?.id) {
          console.log('✅ Steam 数据已恢复！');
        } else {
          console.log('❌ Steam 数据仍然缺失，需要进一步排查');
        }
      }, 5000);
      
    } catch (error) {
      console.error('❌ 验证握手值失败:', error);
    }
    
    console.groupEnd();
  };

  // Steam用户信息
  handleGetUserInfo = async () => {
    const { token } = this.props.auth;
    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/user-info', {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('user-info', data);
    } catch (error) {
      this.updateTestResults('user-info', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // Steam拥有的游戏
  handleGetOwnedGames = async () => {
    const { token } = this.props.auth;
    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/owned-games', {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('owned-games', data);
    } catch (error) {
      this.updateTestResults('owned-games', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 游戏详情
  handleGetGameDetails = async () => {
    const { token } = this.props.auth;
    const { appIdInput } = this.state;
    
    if (!appIdInput) {
      alert('请输入Steam App ID');
      return;
    }

    this.setState({ isLoading: true });
    
    try {
      const response = await fetch(`/api/v1/steam/game-details?appId=${appIdInput}`, {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('game-details', data);
    } catch (error) {
      this.updateTestResults('game-details', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 游戏成就
  handleGetGameAchievements = async () => {
    const { token } = this.props.auth;
    const { appIdInput } = this.state;
    
    if (!appIdInput) {
      alert('请输入Steam App ID');
      return;
    }

    this.setState({ isLoading: true });
    
    try {
      const response = await fetch(`/api/v1/steam/game-achievements?appId=${appIdInput}`, {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('game-achievements', data);
    } catch (error) {
      this.updateTestResults('game-achievements', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 用户游戏成就
  handleGetUserGameAchievements = async () => {
    const { token } = this.props.auth;
    const { appIdInput, steamIdInput } = this.state;
    
    if (!appIdInput || !steamIdInput) {
      alert('请输入Steam App ID和Steam ID');
      return;
    }

    this.setState({ isLoading: true });
    
    try {
      const response = await fetch(`/api/v1/steam/user-game-achievements?appId=${appIdInput}&steamId=${steamIdInput}`, {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('user-game-achievements', data);
    } catch (error) {
      this.updateTestResults('user-game-achievements', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 游戏时长
  handleGetGamePlaytime = async () => {
    const { token } = this.props.auth;
    const { appIdInput } = this.state;
    
    if (!appIdInput) {
      alert('请输入Steam App ID');
      return;
    }

    this.setState({ isLoading: true });
    
    try {
      const response = await fetch(`/api/v1/steam/game-playtime?appId=${appIdInput}`, {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('game-playtime', data);
    } catch (error) {
      this.updateTestResults('game-playtime', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 心愿单
  handleGetWishlist = async () => {
    const { token } = this.props.auth;
    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/wishlist', {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('wishlist', data);
    } catch (error) {
      this.updateTestResults('wishlist', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 好友列表
  handleGetFriendsList = async () => {
    const { token } = this.props.auth;
    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/friends-list', {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('friends-list', data);
    } catch (error) {
      this.updateTestResults('friends-list', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 最近游玩游戏
  handleGetRecentGames = async () => {
    const { token } = this.props.auth;
    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/recent-games', {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('recent-games', data);
    } catch (error) {
      this.updateTestResults('recent-games', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 用户等级
  handleGetUserLevel = async () => {
    const { token } = this.props.auth;
    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/user-level', {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('user-level', data);
    } catch (error) {
      this.updateTestResults('user-level', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 断开Steam连接
  handleDisconnectSteam = async () => {
    const { token } = this.props.auth;
    
    // eslint-disable-next-line no-restricted-globals
    if (!confirm('确定要断开Steam连接吗？')) {
      return;
    }

    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/disconnect', {
        method: 'DELETE',
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('disconnect', data);
    } catch (error) {
      this.updateTestResults('disconnect', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 同步Steam数据
  handleSyncSteamData = async () => {
    const { token } = this.props.auth;
    this.setState({ isLoading: true });
    
    try {
      const response = await fetch('/api/v1/steam/sync', {
        method: 'POST',
        headers: { 'Authorization': `JWT ${token}` }
      });
      const data = await response.json();
      this.updateTestResults('sync', data);
    } catch (error) {
      this.updateTestResults('sync', { error: error.message });
    }
    
    this.setState({ isLoading: false });
  };

  // 刷新用户信息
  handleRefreshUserInfo = async () => {
    const { token } = this.props.auth;
    console.log('=== 手动刷新用户信息测试 ===');
    this.setState({ isLoading: true });
    
    // 测试方法1: 直接调用getInitialInfo action
    console.log('1. 调用getInitialInfo action...');
    this.props.getInitialInfo(token);
    
    // 测试方法2: 调用validateUserHandshake
    console.log('2. 调用validateUserHandshake...');
    try {
      const response = await fetch('/api/v1/user/profile/validate-handshake', {
        method: 'POST',
        headers: { 
          'Authorization': `JWT ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });
      const data = await response.json();
      
      if (data.success) {
        console.log('validateUserHandshake响应:', data);
        this.updateTestResults('user-refresh', { message: '用户信息已刷新', data: data.data });
      } else {
        console.log('validateUserHandshake失败:', data);
        this.updateTestResults('user-refresh', { error: '刷新失败', data });
      }
    } catch (error) {
      console.error('validateUserHandshake错误:', error);
      this.updateTestResults('user-refresh', { error: error.message });
    }
    
    // 测试方法3: 直接调用get-initial-info API
    setTimeout(() => {
      this.testGetInitialInfoAPI(token);
    }, 1000);
    
    this.setState({ isLoading: false });
  };

  // 🔧 新增：实时监控Steam绑定过程
  handleMonitorSteamBinding = () => {
    console.log('=== 开始监控Steam绑定过程 ===');
    
    // 开始监控前清理控制台
    console.clear();
    
    // 设置监控标志
    this.steamBindingMonitor = true;
    
    // 输出监控说明
    console.log('📡 Steam绑定监控已启动');
    console.log('🔍 请现在尝试Steam绑定，此控制台将显示详细过程');
    console.log('📋 监控内容包括：');
    console.log('   - URL变化');
    console.log('   - 网络请求');
    console.log('   - 状态变更');
    console.log('   - 错误信息');
    console.log('---');
    
    // 监控URL变化
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    
    window.history.pushState = function() {
      console.log('🔄 URL变化 (pushState):', arguments[2]);
      return originalPushState.apply(window.history, arguments);
    };
    
    window.history.replaceState = function() {
      console.log('🔄 URL变化 (replaceState):', arguments[2]);
      return originalReplaceState.apply(window.history, arguments);
    };
    
    // 监控window location变化
    let currentLocation = window.location.href;
    const locationMonitor = setInterval(() => {
      if (window.location.href !== currentLocation) {
        console.log('🌐 Location变化:', {
          from: currentLocation,
          to: window.location.href,
          search: window.location.search
        });
        currentLocation = window.location.href;
        
        // 检查是否有Steam相关参数
        const params = new URLSearchParams(window.location.search);
        if (params.has('error') || params.has('success')) {
          console.log('🎯 检测到Steam回调参数:', Object.fromEntries(params));
        }
      }
    }, 500);
    
    // 5分钟后自动停止监控
    setTimeout(() => {
      if (this.steamBindingMonitor) {
        this.handleStopSteamMonitoring();
      }
    }, 5 * 60 * 1000);
    
    // 更新按钮状态
    this.setState({ 
      testResults: {
        ...this.state.testResults,
        'steam-monitor': {
          data: { 
            status: 'monitoring',
            message: '正在监控Steam绑定过程，请查看控制台输出',
            startTime: new Date().toISOString()
          },
          timestamp: new Date().toLocaleString()
        }
      }
    });
    
    // 存储清理函数
    this.monitorCleanup = {
      locationMonitor,
      originalPushState,
      originalReplaceState
    };
  };

  // 🔧 新增：停止Steam绑定监控
  handleStopSteamMonitoring = () => {
    console.log('📡 Steam绑定监控已停止');
    
    this.steamBindingMonitor = false;
    
    // 清理监控
    if (this.monitorCleanup) {
      clearInterval(this.monitorCleanup.locationMonitor);
      window.history.pushState = this.monitorCleanup.originalPushState;
      window.history.replaceState = this.monitorCleanup.originalReplaceState;
      this.monitorCleanup = null;
    }
    
    // 更新状态
    this.setState({ 
      testResults: {
        ...this.state.testResults,
        'steam-monitor': {
          data: { 
            status: 'stopped',
            message: '监控已停止',
            endTime: new Date().toISOString()
          },
          timestamp: new Date().toLocaleString()
        }
      }
    });
  };

  // 🔧 新增：检查Steam配置
  handleCheckSteamConfig = async () => {
    const { token } = this.props.auth;
    console.log('=== 检查Steam配置 ===');
    this.setState({ isLoading: true });
    
    try {
      // 检查Steam认证端点是否可用
      console.log('1. 检查Steam认证端点...');
      try {
        const authResponse = await fetch('/api/v1/auth/steam', {
          method: 'HEAD',  // 只检查端点是否存在
          headers: { 'Authorization': `JWT ${token}` }
        });
        console.log('Steam认证端点状态:', authResponse.status);
      } catch (authError) {
        console.log('Steam认证端点检查失败:', authError.message);
      }
      
      // 检查Steam API配置
      console.log('2. 检查Steam API配置...');
      const configTests = {
        authEndpoint: '/api/v1/auth/steam',
        callbackEndpoint: '/api/v1/auth/steam/callback',
        userInfoEndpoint: '/api/v1/steam/user-info',
        healthCheck: 'Steam配置检查完成'
      };
      
      this.updateTestResults('steam-config', {
        status: 'checked',
        message: 'Steam配置检查完成',
        endpoints: configTests,
        recommendations: [
          '如果绑定仍然失败，请检查后端日志',
          '确认Steam OpenID配置正确',
          '验证数据库连接和更新操作',
          '检查权限获取服务是否正常'
        ]
      });
      
    } catch (error) {
      console.error('配置检查出错:', error);
      this.updateTestResults('steam-config', { 
        status: 'error',
        error: error.message,
        message: '配置检查过程中出现错误'
      });
    }
    
    console.log('===========================');
    this.setState({ isLoading: false });
  };

  // 🔧 新增：重试Steam绑定
  handleRetrySteamBinding = () => {
    console.log('=== 重试Steam绑定 ===');
    console.log('重定向到Steam连接页面...');
    
    // 清除之前的测试结果
    this.setState({
      testResults: {}
    });
    
    // 重定向到Steam绑定页面
    window.location.href = '/api/v1/auth/steam';
  };

  // 🔧 新增：专门诊断Steam绑定失败的详细分析
  handleDiagnoseSteamBindingFailure = async () => {
    const { token } = this.props.auth;
    console.log('=== Steam Callback Failed 详细诊断 ===');
    this.setState({ isLoading: true });
    
    try {
      // 1. 检查当前页面URL和参数
      console.log('1. URL诊断信息:');
      console.log('   当前URL:', window.location.href);
      console.log('   URL参数:', window.location.search);
      
      const urlParams = new URLSearchParams(window.location.search);
      const allParams = {};
      for (let [key, value] of urlParams) {
        allParams[key] = value;
      }
      console.log('   解析的参数:', allParams);
      
      // 2. 检查用户当前状态
      console.log('2. 用户状态检查:');
      console.log('   用户令牌存在:', !!token);
      console.log('   用户信息:', this.props.auth.user);
      console.log('   Steam连接状态:', this.props.auth.user?.connectedAccounts?.steam);
      
      // 3. 尝试获取后端日志（如果有相关API）
      console.log('3. 后端状态检查:');
      try {
        // 检查用户最新信息
        const userResponse = await fetch('/api/v1/account/get-initial-info', {
          headers: { 'Authorization': `JWT ${token}` }
        });
        const userData = await userResponse.json();
        console.log('   后端用户数据:', userData);
        
        if (userData.user?.connectedAccounts?.steam?.id) {
          console.log('   🎉 意外发现：Steam实际上已经绑定成功！');
          console.log('   Steam ID:', userData.user.connectedAccounts.steam.id);
          console.log('   Steam用户名:', userData.user.connectedAccounts.steam.username);
          console.log('   可能是前端显示错误或缓存问题');
        } else {
          console.log('   ❌ 确认：Steam确实未绑定');
        }
      } catch (apiError) {
        console.log('   API调用失败:', apiError.message);
      }
      
      // 4. 分析可能的失败原因
      console.log('4. 失败原因分析:');
      const possibleCauses = [
        '🔹 数据库更新失败 - 检查数据库连接和User表结构',
        '🔹 权限获取异常 - Utility.getUserPermission()出错',
        '🔹 地区信息获取失败 - Utility.getUserRegion()出错',
        '🔹 日志记录服务异常 - LogService.logSteamAction()出错',
        '🔹 Steam用户信息获取失败 - steamService.getSteamUserInfo()返回错误',
        '🔹 Session状态异常 - 会话过期或数据损坏',
        '🔹 网络问题 - Steam API调用超时或失败'
      ];
      
      possibleCauses.forEach(cause => console.log('   ' + cause));
      
      // 5. 建议的排查步骤
      console.log('5. 建议排查步骤:');
      const troubleshootingSteps = [
        '📋 查看后端控制台日志，搜索"Steam callback failed"',
        '📋 检查数据库连接状态和User表结构',
        '📋 验证Steam API配置（API Key、回调URL等）',
        '📋 测试权限和地区信息获取服务',
        '📋 检查日志记录服务是否正常工作',
        '📋 使用"重试Steam绑定"按钮重新尝试'
      ];
      
      troubleshootingSteps.forEach(step => console.log('   ' + step));
      
      // 记录到测试结果
      this.updateTestResults('callback-failed-diagnosis', {
        status: 'analyzed',
        timestamp: new Date().toISOString(),
        urlParams: allParams,
        userStatus: {
          hasToken: !!token,
          steamConnected: !!this.props.auth.user?.connectedAccounts?.steam?.id
        },
        possibleCauses,
        troubleshootingSteps,
        recommendation: '建议先查看后端日志确定具体错误原因，然后使用重试功能重新尝试绑定'
      });
      
    } catch (error) {
      console.error('🚨 诊断过程出错:', error);
      this.updateTestResults('callback-failed-diagnosis', { 
        status: 'error',
        error: error.message,
        message: '诊断过程中出现错误'
      });
    }
    
    console.log('=================================');
    this.setState({ isLoading: false });
  };

  // 🔧 新增：专门诊断Steam绑定失败的详细测试
  handleDiagnoseSteamBinding = async () => {
    const { token } = this.props.auth;
    console.log('=== Steam绑定失败诊断 ===');
    this.setState({ isLoading: true });
    
    try {
      // 1. 检查用户当前状态
      console.log('1. 检查当前用户状态...');
      const userResponse = await fetch('/api/v1/account/get-initial-info', {
        headers: { 'Authorization': `JWT ${token}` }
      });
      const userData = await userResponse.json();
      console.log('当前用户数据:', userData);
      
      if (userData.user?.connectedAccounts?.steam?.id) {
        console.log('✅ Steam账户已连接:', userData.user.connectedAccounts.steam);
        this.updateTestResults('diagnose-binding', { 
          status: 'connected',
          message: 'Steam账户已经连接成功',
          steamData: userData.user.connectedAccounts.steam
        });
      } else {
        console.log('❌ Steam账户未连接');
        
        // 2. 尝试模拟检查后端状态
        console.log('2. 检查后端Steam配置...');
        try {
          const configResponse = await fetch('/api/v1/steam/health-check', {
            headers: { 'Authorization': `JWT ${token}` }
          });
          const configData = await configResponse.json();
          console.log('Steam配置检查:', configData);
        } catch (configError) {
          console.log('Steam配置检查失败:', configError.message);
        }
        
        this.updateTestResults('diagnose-binding', { 
          status: 'not_connected',
          message: 'Steam账户未连接，可能在绑定过程中出现异常',
          suggestions: [
            '检查后端日志查看具体错误原因',
            '验证Steam OpenID配置是否正确',
            '确认数据库连接和用户更新操作',
            '检查权限获取和日志记录是否正常'
          ]
        });
      }
    } catch (error) {
      console.error('诊断过程出错:', error);
      this.updateTestResults('diagnose-binding', { 
        status: 'error',
        error: error.message,
        message: '诊断过程中出现错误'
      });
    }
    
    console.log('===========================');
    this.setState({ isLoading: false });
  };

  // 测试直接API调用
  testGetInitialInfoAPI = async (token) => {
    console.log('3. 直接调用/api/v1/account/get-initial-info API...');
    
    try {
      const response = await fetch('/api/v1/account/get-initial-info', {
        method: 'GET',
        headers: { 
          'Authorization': `JWT ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      console.log('get-initial-info API响应完整数据:', data);
      
      if (data.user && data.user.connectedAccounts) {
        console.log('API返回的Steam数据:', data.user.connectedAccounts.steam);
        console.log('API返回的Twitch数据:', data.user.connectedAccounts.twitch);
        console.log('API返回的YouTube数据:', data.user.connectedAccounts.youtube);
        
        // 检查各平台数据完整性
        const platforms = ['steam', 'twitch', 'twitter', 'youtube'];
        platforms.forEach(platform => {
          const platformData = data.user.connectedAccounts[platform];
          if (platformData && platformData.id) {
            console.log(`✓ ${platform}: 连接正常 (ID: ${platformData.id})`);
          } else {
            console.log(`✗ ${platform}: 连接丢失或不存在`);
          }
        });
        
        // 如果只有Steam丢失，高亮显示
        const steamExists = data.user.connectedAccounts.steam?.id;
        const twitchExists = data.user.connectedAccounts.twitch?.id;
        const twitterExists = data.user.connectedAccounts.twitter?.id;
        const youtubeExists = data.user.connectedAccounts.youtube?.id;
        
        if (!steamExists && (twitchExists || twitterExists || youtubeExists)) {
          console.log('🚨 后端API确认：只有Steam数据丢失，其他平台数据正常！');
        }
      } else {
        console.log('API响应缺少用户连接账户信息');
      }
      
      this.updateTestResults('get-initial-info', { data, timestamp: new Date().toLocaleString() });
    } catch (error) {
      console.error('直接API调用失败:', error);
      this.updateTestResults('get-initial-info', { error: error.message });
    }
    
    console.log('================================');
  };
  updateTestResults = (type, data) => {
    this.setState(prevState => ({
      testResults: {
        ...prevState.testResults,
        [type]: {
          data,
          timestamp: new Date().toLocaleString()
        }
      }
    }));
  };

  // 渲染按钮组
  renderApiButtons = () => {
    const { isLoading, appIdInput, steamIdInput } = this.state;
    
    return (
      <div className="steam-test__buttons">
        {/* 用户信息相关（保留核心操作） */}
        <div className="button-group">
          <h3>用户信息相关</h3>
          
          {/* 刷新用户信息按钮单独一行 */}
          <div style={{ marginBottom: '15px' }}>
            <button 
              onClick={this.handleRefreshUserInfo}
              disabled={isLoading}
              className="btn btn-warning"
              style={{ 
                backgroundColor: '#ffc107', 
                color: '#212529',
                padding: '10px 15px',
                fontSize: '14px',
                fontWeight: '500',
                width: '100%'
              }}
            >
              刷新用户信息
            </button>
          </div>

          <div style={{ 
            fontSize: '12px', 
            color: '#6c757d', 
            margin: '0 0 20px 0', 
            padding: '8px 12px', 
            backgroundColor: '#f8f9fa', 
            borderRadius: '4px', 
            border: '1px solid #e9ecef',
            lineHeight: '1.4'
          }}>
            <strong style={{ color: '#495057' }}>说明：</strong>连接平台后可通过 validateUserHandshake 同步最新数据
          </div>

          {/* 基础信息按钮 - 2列布局 */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '10px',
            marginBottom: '15px'
          }}>
            <button 
              onClick={this.handleGetUserInfo}
              disabled={isLoading}
              className="btn btn-primary"
              style={{ padding: '8px 12px', fontSize: '13px' }}
            >
              获取Steam用户信息
            </button>
            <button 
              onClick={this.handleGetUserLevel}
              disabled={isLoading}
              className="btn btn-primary"
              style={{ padding: '8px 12px', fontSize: '13px' }}
            >
              获取用户等级
            </button>
          </div>

          {/* 游戏相关按钮 - 2列布局 */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '10px',
            marginBottom: '15px'
          }}>
            <button 
              onClick={this.handleGetOwnedGames}
              disabled={isLoading}
              className="btn btn-primary"
              style={{ padding: '8px 12px', fontSize: '13px' }}
            >
              获取拥有的游戏
            </button>
            <button 
              onClick={this.handleGetRecentGames}
              disabled={isLoading}
              className="btn btn-primary"
              style={{ padding: '8px 12px', fontSize: '13px' }}
            >
              获取最近游玩游戏
            </button>
          </div>

          {/* 社交相关按钮 - 2列布局 */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '10px'
          }}>
            <button 
              onClick={this.handleGetWishlist}
              disabled={isLoading}
              className="btn btn-primary"
              style={{ padding: '8px 12px', fontSize: '13px' }}
            >
              获取心愿单
            </button>
            <button 
              onClick={this.handleGetFriendsList}
              disabled={isLoading}
              className="btn btn-primary"
              style={{ padding: '8px 12px', fontSize: '13px' }}
            >
              获取好友列表
            </button>
          </div>
        </div>

        {/* 游戏相关 */}
        <div className="button-group" style={{ marginTop: '20px' }}>
          <h3>游戏相关</h3>
          <div className="input-group">
            <input
              type="text"
              value={appIdInput}
              onChange={(e) => this.setState({ appIdInput: e.target.value })}
              placeholder="输入Steam App ID (如: 730)"
              className="input-field"
            />
            <button 
              onClick={this.handleGetGameDetails}
              disabled={isLoading || !appIdInput}
              className="btn btn-secondary"
            >
              获取游戏详情
            </button>
          </div>

          <div className="input-group">
            <input
              type="text"
              value={appIdInput}
              onChange={(e) => this.setState({ appIdInput: e.target.value })}
              placeholder="输入Steam App ID (如: 730)"
              className="input-field"
            />
            <button 
              onClick={this.handleGetGamePlaytime}
              disabled={isLoading || !appIdInput}
              className="btn btn-secondary"
            >
              获取游戏时长
            </button>
          </div>
          
          <div className="input-group">
            <input
              type="text"
              value={appIdInput}
              onChange={(e) => this.setState({ appIdInput: e.target.value })}
              placeholder="输入Steam App ID (如: 730)"
              className="input-field"
            />
            <button 
              onClick={this.handleGetGameAchievements}
              disabled={isLoading || !appIdInput}
              className="btn btn-secondary"
            >
              获取游戏成就列表
            </button>
          </div>
        </div>

        {/* 成就相关 */}
        <div className="button-group" style={{ marginTop: '20px' }}>
          <h3>成就相关</h3>
          <div className="input-group">
            <input
              type="text"
              value={appIdInput}
              onChange={(e) => this.setState({ appIdInput: e.target.value })}
              placeholder="Steam App ID"
              className="input-field"
            />
            <input
              type="text"
              value={steamIdInput}
              onChange={(e) => this.setState({ steamIdInput: e.target.value })}
              placeholder="Steam用户ID"
              className="input-field"
            />
            <button 
              onClick={this.handleGetUserGameAchievements}
              disabled={isLoading || !appIdInput || !steamIdInput}
              className="btn btn-secondary"
            >
              获取用户游戏成就
            </button>
          </div>
        </div>

        {/* 管理操作 */}
        <div className="button-group" style={{ marginTop: '20px' }}>
          <h3>管理操作</h3>
          <button 
            onClick={this.handleSyncSteamData}
            disabled={isLoading}
            className="btn btn-success"
          >
            同步Steam数据
          </button>
          <button 
            onClick={this.handleDisconnectSteam}
            disabled={isLoading}
            className="btn btn-danger"
            style={{ marginLeft: '10px' }}
          >
            断开Steam连接
          </button>
        </div>
      </div>
    );
  };

  // 渲染测试结果
  renderTestResults = () => {
    const { testResults } = this.state;
    
    return (
      <div className="steam-test__results" style={{
        maxHeight: '80vh',
        minHeight: '600px',
        overflowY: 'auto',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ 
          position: 'sticky', 
          top: '0', 
          backgroundColor: '#f8f9fa', 
          margin: '0 0 20px 0', 
          padding: '10px 0',
          borderBottom: '2px solid #007bff',
          zIndex: 10
        }}>
          测试结果
        </h3>
        {Object.keys(testResults).length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            color: '#6c757d',
            fontSize: '16px'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔍</div>
            <p className="no-results">暂无测试结果</p>
            <p style={{ fontSize: '14px', marginTop: '10px' }}>
              点击上方按钮执行测试，结果将在这里显示
            </p>
          </div>
        ) : (
          <div style={{ paddingBottom: '20px' }}>
            {Object.entries(testResults).map(([type, result]) => (
              <div key={type} className="result-item" style={{
                marginBottom: '20px',
                border: '1px solid #e9ecef',
                borderRadius: '6px',
                backgroundColor: 'white',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                overflow: 'hidden'
              }}>
                <div className="result-header" style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  padding: '12px 16px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <h4 style={{ 
                    margin: '0', 
                    fontSize: '16px', 
                    fontWeight: '600' 
                  }}>
                    {this.getApiTypeLabel(type)}
                  </h4>
                  <span className="timestamp" style={{
                    fontSize: '12px',
                    color: 'white',
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}>
                    {result.timestamp}
                  </span>
                </div>
                <div className="result-content" style={{
                  padding: '16px',
                  maxHeight: '400px',
                  overflowY: 'auto',
                  backgroundColor: '#ffffff'
                }}>
                  <pre style={{
                    margin: '0',
                    fontSize: '12px',
                    lineHeight: '1.4',
                    color: '#212529',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRadius: '4px',
                    padding: '12px',
                    overflow: 'auto',
                    fontFamily: "'Fira Code', 'Monaco', 'Consolas', monospace"
                  }}>
                    {JSON.stringify(result.data, null, 2)}
                  </pre>
                </div>
              </div>
            ))}
          </div>
        )}
        
        {/* 底部提示 */}
        {Object.keys(testResults).length > 0 && (
          <div style={{
            position: 'sticky',
            bottom: '0',
            backgroundColor: '#f8f9fa',
            padding: '10px 0',
            borderTop: '1px solid #dee2e6',
            textAlign: 'center',
            fontSize: '12px',
            color: '#6c757d'
          }}>
            共 {Object.keys(testResults).length} 条测试结果 • 使用滚动查看更多内容
          </div>
        )}
      </div>
    );
  };

  // 获取API类型标签
  getApiTypeLabel = (type) => {
    const labels = {
      'callback-failed-diagnosis': '🚨 Callback Failed 诊断',
      'steam-monitor': '📡 Steam绑定监控',
      'steam-config': '⚙️ Steam配置检查',
      'diagnose-binding': '🔍 Steam绑定诊断',
      'user-refresh': '刷新用户信息',
      'get-initial-info': '获取初始用户信息',
      'user-info': 'Steam用户信息',
      'owned-games': '拥有的游戏',
      'game-details': '游戏详情',
      'game-playtime': '游戏时长',
      'game-achievements': '游戏成就列表',
      'user-game-achievements': '用户游戏成就',
      'wishlist': '心愿单',
      'friends-list': '好友列表',
      'recent-games': '最近游玩游戏',
      'user-level': '用户等级',
      'disconnect': '断开连接',
      'sync': '同步数据'
    };
    return labels[type] || type;
  };

  render() {
    const { isLoading, userDataLoaded } = this.state;
    const { user } = this.props.auth;

    // 如果用户数据还没有完全加载，显示加载状态
    if (!user?.connectedAccounts && !userDataLoaded) {
      return (
        <section className="SteamTestPage">
          <div className="SteamTestPage__wrapper">
            <div className="SteamTestPage__container">
              <div className="SteamTestPage__header">
                <h2>Steam API 测试页面</h2>
                <div className="user-info">
                  <p>正在加载用户信息...</p>
                </div>
              </div>
              <div className="loading-overlay">
                <div className="loading-spinner">正在获取用户数据...</div>
              </div>
            </div>
          </div>
        </section>
      );
    }

    return (
      <section className="SteamTestPage">
        <div className="SteamTestPage__wrapper">
          <div className="SteamTestPage__container">
            <div className="SteamTestPage__header">
              <h2>Steam API 测试页面</h2>
              <div className="user-info">
                <p>当前用户: {user?.username || 'N/A'}</p>
                {/* 移除 callback_failed 错误警告与诊断块，保留更简洁的头部 */}
                {/* 平台连接状态对比区保留 */}
              </div>
              {/* 保留平台连接状态对比与时序调试信息，其它诊断说明已移除 */}
            </div>

            {isLoading && (
              <div className="loading-overlay">
                <div className="loading-spinner">加载中...</div>
              </div>
            )}

            <div className="SteamTestPage__content" style={{
              display: 'grid',
              gridTemplateColumns: '480px 1fr',
              gap: '20px',
              minHeight: 'calc(100vh - 300px)',
              padding: '20px 0'
            }}>
              <div className="test-section" style={{
                maxHeight: '80vh',
                overflowY: 'auto',
                padding: '20px',
                backgroundColor: '#ffffff',
                border: '1px solid #e9ecef',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                {this.renderApiButtons()}
              </div>
              
              <div className="results-section">
                {this.renderTestResults()}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

SteamTestPage.propTypes = {
  auth: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  getInitialInfo: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = (dispatch) => ({
  getInitialInfo: (token) => dispatch({ type: 'GET_INITIAL_INFO', payload: { token } })
});

export default connect(mapStateToProps, mapDispatchToProps)(SteamTestPage);
